module.exports = __webpack_public_path__ + "static/img/show3.7b08519.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/show3.jpeg
// module id = chSg
// module chunks = 2